import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CreditCard, Wallet, Building, ShieldCheck, Lock } from 'lucide-react';
import { useAppContext } from '../contexts/AppContext';
export function PaymentScreen() {
  const navigate = useNavigate();
  const {
    bookingData
  } = useAppContext();
  const [method, setMethod] = useState('card');
  const [isProcessing, setIsProcessing] = useState(false);
  const total = bookingData?.fee ? bookingData.fee + bookingData.platformFee : 0;
  const handlePay = () => {
    setIsProcessing(true);
    // Simulate payment processing
    setTimeout(() => {
      setIsProcessing(false);
      navigate('/booking-confirmation');
    }, 2000);
  };
  return <div className="min-h-screen bg-ui-bg flex flex-col" data-id="element-1108">
      <div className="pt-12 px-6 pb-4 bg-white shadow-sm z-10" data-id="element-1109">
        <div className="flex items-center" data-id="element-1110">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 rounded-full hover:bg-ui-card" data-id="element-1111">
            <ArrowLeft size={24} className="text-text-main" data-id="element-1112" />
          </button>
          <h1 className="text-xl font-bold text-text-main ml-2" data-id="element-1113">Payment</h1>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-6 space-y-6" data-id="element-1114">
        <div className="bg-brand-primary text-white p-6 rounded-2xl shadow-md text-center" data-id="element-1115">
          <p className="text-brand-light text-sm mb-1" data-id="element-1116">Total to pay</p>
          <h2 className="text-4xl font-bold mb-4" data-id="element-1117">₦{total.toLocaleString()}</h2>
          <div className="inline-flex items-center bg-white/20 px-3 py-1.5 rounded-full text-xs font-medium backdrop-blur-sm" data-id="element-1118">
            <Lock size={12} className="mr-1.5" data-id="element-1119" /> Secure Escrow Payment
          </div>
        </div>

        <div data-id="element-1120">
          <h3 className="font-bold text-text-main mb-3" data-id="element-1121">
            Select Payment Method
          </h3>
          <div className="space-y-3" data-id="element-1122">
            <button onClick={() => setMethod('card')} className={`w-full flex items-center p-4 rounded-xl border-2 transition-all ${method === 'card' ? 'border-brand-primary bg-brand-light' : 'border-ui-border bg-white'}`} data-id="element-1123">
              <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mr-4" data-id="element-1124">
                <CreditCard size={20} data-id="element-1125" />
              </div>
              <div className="flex-1 text-left" data-id="element-1126">
                <h4 className="font-bold text-text-main" data-id="element-1127">
                  Debit / Credit Card
                </h4>
                <p className="text-xs text-text-secondary" data-id="element-1128">
                  Paystack secure checkout
                </p>
              </div>
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${method === 'card' ? 'border-brand-primary' : 'border-gray-300'}`} data-id="element-1129">
                {method === 'card' && <div className="w-2.5 h-2.5 bg-brand-primary rounded-full" data-id="element-1130" />}
              </div>
            </button>

            <button onClick={() => setMethod('transfer')} className={`w-full flex items-center p-4 rounded-xl border-2 transition-all ${method === 'transfer' ? 'border-brand-primary bg-brand-light' : 'border-ui-border bg-white'}`} data-id="element-1131">
              <div className="w-10 h-10 bg-green-100 text-green-600 rounded-full flex items-center justify-center mr-4" data-id="element-1132">
                <Building size={20} data-id="element-1133" />
              </div>
              <div className="flex-1 text-left" data-id="element-1134">
                <h4 className="font-bold text-text-main" data-id="element-1135">Bank Transfer</h4>
                <p className="text-xs text-text-secondary" data-id="element-1136">
                  Generate account number
                </p>
              </div>
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${method === 'transfer' ? 'border-brand-primary' : 'border-gray-300'}`} data-id="element-1137">
                {method === 'transfer' && <div className="w-2.5 h-2.5 bg-brand-primary rounded-full" data-id="element-1138" />}
              </div>
            </button>

            <button onClick={() => setMethod('wallet')} className={`w-full flex items-center p-4 rounded-xl border-2 transition-all ${method === 'wallet' ? 'border-brand-primary bg-brand-light' : 'border-ui-border bg-white'}`} data-id="element-1139">
              <div className="w-10 h-10 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mr-4" data-id="element-1140">
                <Wallet size={20} data-id="element-1141" />
              </div>
              <div className="flex-1 text-left" data-id="element-1142">
                <h4 className="font-bold text-text-main" data-id="element-1143">Whiz Wallet</h4>
                <p className="text-xs text-text-secondary" data-id="element-1144">Balance: ₦45,000</p>
              </div>
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${method === 'wallet' ? 'border-brand-primary' : 'border-gray-300'}`} data-id="element-1145">
                {method === 'wallet' && <div className="w-2.5 h-2.5 bg-brand-primary rounded-full" data-id="element-1146" />}
              </div>
            </button>
          </div>
        </div>

        {method === 'card' && <div className="bg-white p-4 rounded-xl border border-ui-border space-y-4 animate-fade-in" data-id="element-1147">
            <div data-id="element-1148">
              <label className="text-xs font-medium text-text-secondary mb-1 block" data-id="element-1149">
                Card Number
              </label>
              <input type="text" placeholder="0000 0000 0000 0000" className="w-full p-3 bg-ui-card border border-ui-border rounded-lg outline-none focus:border-brand-primary" data-id="element-1150" />
            </div>
            <div className="flex space-x-4" data-id="element-1151">
              <div className="flex-1" data-id="element-1152">
                <label className="text-xs font-medium text-text-secondary mb-1 block" data-id="element-1153">
                  Expiry
                </label>
                <input type="text" placeholder="MM/YY" className="w-full p-3 bg-ui-card border border-ui-border rounded-lg outline-none focus:border-brand-primary" data-id="element-1154" />
              </div>
              <div className="flex-1" data-id="element-1155">
                <label className="text-xs font-medium text-text-secondary mb-1 block" data-id="element-1156">
                  CVV
                </label>
                <input type="text" placeholder="123" className="w-full p-3 bg-ui-card border border-ui-border rounded-lg outline-none focus:border-brand-primary" data-id="element-1157" />
              </div>
            </div>
          </div>}
      </div>

      <div className="p-6 bg-white border-t border-ui-border" data-id="element-1158">
        <button onClick={handlePay} disabled={isProcessing} className="w-full bg-brand-primary text-white font-semibold py-4 rounded-xl shadow-md disabled:opacity-70 flex justify-center items-center transition-all" data-id="element-1159">
          {isProcessing ? <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-1160"></div> : `Pay ₦${total.toLocaleString()}`}
        </button>
        <div className="flex items-center justify-center mt-4 text-xs text-text-secondary" data-id="element-1161">
          <ShieldCheck size={14} className="mr-1 text-status-success" data-id="element-1162" />{' '}
          Payments are secure and encrypted
        </div>
      </div>
    </div>;
}